import { defineStore } from 'pinia';

export const useTravelPlusStore = defineStore('travelPlus', {
    state: () => ({
        consultsAvailable: 0,
        loadingConsultations: false,
    }),
    getters: {},
    actions: {
        getConsultations() {
            this.loadingConsultations = true;

            ApiService.apiCall(`/travel-plus/consultations`, 'get')
                .then((response) => {
                    this.consultsAvailable = response.data.consults_available;
                    this.loadingConsultations = false;
                })
                .catch((response) => {
                    this.loadingConsultations = false;
                });
        },
    },
});
